import ActionInterest from './actionInterest.vue'
export default ActionInterest
